import React, {useEffect, useState} from 'react';
import Modal from "../components/modal";
import DisclaimerModal from "../components/disclaimer";
import {useShallowPickSelector} from "../redux";
import {useDispatch} from "react-redux";
import * as AppStore from '../redux/app';
import AiProfitAlarm from "../components/signals/tabs/aiProfitAlarm";
import AiSpotters from "../components/signals/tabs/aiSpotters";
import {useLocation} from "react-router-dom";

let timeout;
let timeout1;

const Signals = () => {
    const {showDisclaimerModal} = useShallowPickSelector('app', ['showDisclaimerModal']);
    const location = useLocation();
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(true);
    const [activeTab, setActiveTab] = useState(location?.state?.tab ?? 'tab1');
    const [prevTab, setPrevTab] = useState(location?.state?.tab ? location?.state?.tab === 'tab1' ? 'tab2' : 'tab1' : 'tab2');
    const [refetch, setRefetch] = useState(false);

    const handleTabClick = (tab) => {
        if (tab !== activeTab) {
            setPrevTab(activeTab);
            setTimeout(() => {
                setActiveTab(tab);
            }, 200)
        } else {
            setRefetch(true)
            timeout1 = setTimeout(() => {
                setRefetch(false)
            }, 100)
        }
    };

    useEffect(() => {
        setShowModal(showDisclaimerModal)
        return () => {
            clearTimeout(timeout);
            clearTimeout(timeout1);
        }
    }, [])

    const closeModal = () => {
        const modalBackdrop = document.querySelector('.modal-backdrop');
        const modal = document.querySelector('.modal');
        modalBackdrop.style.animation = 'fadeOut 0.3s forwards';
        modal.style.animation = 'slideUp 0.3s forwards';

        timeout = setTimeout(() => {
            setShowModal(false);
            dispatch(AppStore.actions.setShowDisclaimerModal(false))
        }, 300);
    };

    return (
        <div className="container">
            <div className="tabs-container">
                <div className="tabs-header">
                    <div className="tabs-header-buttons">
                        <button
                            className={`tab-button lineNumber1 ${activeTab === "tab1" ? "active" : ""}`}
                            onClick={() => handleTabClick("tab1")}
                        >
                            AI Profit Alarms
                        </button>
                        <button
                            className={`tab-button lineNumber1 ${activeTab === "tab2" ? "active" : ""}`}
                            onClick={() => handleTabClick("tab2")}
                        >
                            AI Spotter
                        </button>
                    </div>
                    <div className={`active-indicator ${activeTab}`} />
                </div>
                <div className="tabs-content">
                    {activeTab === 'tab1' && (
                        <div
                            className={`tab-panel tab1 ${
                                prevTab === "tab2" ? "visible enter-from-left" : "visible go-to-left"
                            }`}
                        >
                            <AiProfitAlarm showModal={showModal} refetch={refetch} />
                        </div>
                    )}
                    {activeTab === 'tab2' && (
                        <div
                            className={`tab-panel tab2 ${
                                prevTab === "tab1" ? "visible enter-from-right" : "visible go-to-right"
                            }`}
                        >
                            <AiSpotters showModal={showModal} refetch={refetch} />
                        </div>
                    )}
                </div>
            </div>
            <Modal isOpen={showModal} onClose={() => {}}>
                <DisclaimerModal onClose={closeModal} />
            </Modal>
        </div>
    );
}

export default Signals;
